import { useTranslation } from "react-i18next";
import Stats from "Assets/images/stats.svg";

import "./BuenosAires.scss";

export default function BuenosAires() {
  const { t } = useTranslation();
  const buenosAiresCities = [
    "Bahía Blanca",
    "Cabildo",
    "CABA",
    "Espartillar",
    "Felipe Solá",
    "Goyena",
    "Gral. Daniel Cerri",
    "Juan Cousté",
    "Médanos",
    "Puan",
    "Saavedra",
    "Salliqueló",
  ];

  return (
    <div className="buenos-aires-container">
      <article
        className="commitment-cityLabel"
        style={{
          backgroundColor: "#017DCF20",
          borderLeft: "0.5rem solid #017DCF",
          width: "fit-content",
          padding: "1rem",
        }}
      >
        <h3 className="province" style={{ color: "#017DCF" }}>
          Buenos Aires
        </h3>
        <ul className="city-list">
          {buenosAiresCities.map((city) => (
            <li key={city}>
              <h4 className="city">{city}</h4>
            </li>
          ))}
        </ul>
        <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
          <img
            className="graphic"
            width={160}
            height={160}
            src={Stats}
            alt="estadísticas de compromiso"
          />
          <p className="stats-description-bs">{t("commitment.stats")}</p>
        </div>
      </article>
    </div>
  );
}
